import { IAccrualGeneralJournalAttachmentHeaderMaker } from './i-accrualgeneraljournalattachmentheadermaker.interface';
import { IAccrualGeneralJournalAttachmentHeader } from './i-accrualgeneraljournalattachmentheader.interface';
import { IAccrualGeneralJournalEntryMaker } from './i-accrualgeneraljournalentrymaker.interface';
import { IAccrualGeneralJournalEntry } from './i-accrualgeneraljournalentry.interface';
import { IAccrualGeneralJournalMaker } from './i-accrualgeneraljournalmaker.interface';
import { IAccrualGeneralJournal } from './i-accrualgeneraljournal.interface';

export class AccrualGeneralJournal implements IAccrualGeneralJournal {
    constructor(
        public journalType: string, //Journal
        public journalDate: string, //Batch_Date
        public journalReverseDate: string, //Auto_Reversal_Date
        public journalTitle: string,  //Batch_Title "General Journal"
        public state: string,
        public referenceNo: string,
        public entries: IAccrualGeneralJournalEntry[],
        public attachmentHeader: IAccrualGeneralJournalAttachmentHeader,    //SupDoc
        public accrualTargeDate: Date,      //no mapping to Server object
        public accrualType: AccrualType,    //no mapping to Server object 
    ) {}

    static validation(accrual: AccrualGeneralJournal): string {
        let errStr = null;
        if (!accrual.accrualTargeDate) {
            errStr += "Accrual Target Date is Required\n";
        }
        if (!accrual.referenceNo) {
            errStr += "Accrual ReferenceNo is Required\n";
        }
        if (!accrual.journalTitle) {
            errStr += "Accrual Title is Required\n";
        }
        if (!accrual.accrualType) {
            errStr += "Accrual Type is Required\n";
        }
        if (!accrual.entries || accrual.entries.length === 0) {
            errStr += "Accrual Detail Entries are Required\n";
        }
        return errStr;
    }
}

export class AccrualGeneralJournalMaker implements IAccrualGeneralJournalMaker {
    static create(event: AccrualGeneralJournal) {
        return new AccrualGeneralJournal(
            event.journalType,
            event.journalDate,
            event.journalReverseDate,
            event.journalTitle,
            event.state,
            event.referenceNo,
            event.entries,
            event.attachmentHeader,
            event.accrualTargeDate,
            event.accrualType
        ) 
    }
}

export const enum AccrualType {
    CarRepairAccrual = 1,   //"CarRepairAccrual"
    StorageAccrual = 2      //"StorageAccrual",
}

export class AccrualGeneralJournalEntry  implements IAccrualGeneralJournalEntry {
    constructor (
        public entryType: AccrualGeneralJournalEntryType,
        public accountNo: string,
        public amount: number,
        public memo: string,
        public location: string,
        public transactionDebit: number,  //no mapping to Server object
        public transactionCredit: number, //no mapping to Server object
    ) {}

    static validation(accrualEntry: AccrualGeneralJournalEntry): string {
        let errStr = null;
        if (!accrualEntry.accountNo) {
            errStr += "Accrual Entry Account is Required\n";
        }
        if (!accrualEntry.location) {
            errStr += "Accrual Entry Location is Required\n";
        }
        if (!accrualEntry.entryType) {
            errStr += "Accrual Entry transaction type is Required\n";
        }
        if (!accrualEntry.amount) {
            errStr += "Accrual Entry transaction amount is Required\n";
        }
        return errStr;
    }
}

export const enum AccrualGeneralJournalEntryType {
    glCredit = -1,   
    glDebit = 1      
}

export class AccrualGeneralJournalEntryMaker implements IAccrualGeneralJournalEntryMaker {
    static create(event: AccrualGeneralJournalEntry) {
        return new AccrualGeneralJournalEntry(event.entryType, event.accountNo, event.amount, event.memo, event.location, null, null);
    }
}

export class AccrualGeneralJournalAttachmentHeader implements IAccrualGeneralJournalAttachmentHeader {
    constructor ( 
        public headerId: string,
        public headerName: string, 
        public headerDescription: string, 
        public attachments: [Document],
        public headerFolder: string = "Cash Management"
    ) {}
}

export class AccrualGeneralJournalAttachmentHeaderMaker implements IAccrualGeneralJournalAttachmentHeaderMaker {
    static create(event: AccrualGeneralJournalAttachmentHeader) {
        return new AccrualGeneralJournalAttachmentHeader(event.headerId, event.headerName, event.headerDescription, event.attachments, event.headerFolder);
    }
}
